module.exports = __webpack_public_path__ + "img/Day2_final.152bf874.jpg";